export const P2PAY_CANCEL_WITHDRAWAL_ACTION = 'P2PAY_CANCEL_WITHDRAWAL'
export const P2PAY_CANCEL_WITHDRAWAL_ACTION_VERSION = 1
const P2PAY_WITHDRAW_PAYMENT_NAME = 'P2PAY'

export type P2PayCmReviewReasonCode =
  | 'CM_ADMIN_DECISION_PENDING'
  | 'CM_FINANCE_HOLD_OUTCOME_UNKNOWN'
  | 'CM_FINANCE_DISPATCH_OUTCOME_UNKNOWN'
  | 'CM_FINANCE_RELEASE_OUTCOME_UNKNOWN'
  | 'CM_PROVIDER_REQUEST_OUTCOME_UNKNOWN'
  | 'CM_PROVIDER_REQUEST_PENDING'

export interface P2PayCmReview {
  version?: unknown
  reasonCode?: unknown
  actionFamily?: unknown
  availableActions?: unknown
}

export type P2PayCancellationOutcome =
  | 'ACCEPTED'
  | 'UNKNOWN'
  | 'REJECTED'
  | 'FAILED'

export interface P2PayCancellationRequest {
  transferId: number
  requestId: string
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

const p2PayCmReviewReasonCodes: readonly P2PayCmReviewReasonCode[] = [
  'CM_ADMIN_DECISION_PENDING',
  'CM_FINANCE_HOLD_OUTCOME_UNKNOWN',
  'CM_FINANCE_DISPATCH_OUTCOME_UNKNOWN',
  'CM_FINANCE_RELEASE_OUTCOME_UNKNOWN',
  'CM_PROVIDER_REQUEST_OUTCOME_UNKNOWN',
  'CM_PROVIDER_REQUEST_PENDING',
]

export const isP2PayWithdrawPaymentName = (paymentName: unknown): boolean =>
  typeof paymentName === 'string'
  && paymentName.trim().toUpperCase() === P2PAY_WITHDRAW_PAYMENT_NAME

export const getP2PayCmReviewReasonCode = (
  cmReview: unknown,
): P2PayCmReviewReasonCode | null => {
  if (
    !isRecord(cmReview)
    || cmReview.version !== 1
    || typeof cmReview.reasonCode !== 'string'
    || !p2PayCmReviewReasonCodes.includes(
      cmReview.reasonCode as P2PayCmReviewReasonCode,
    )
  ) {
    return null
  }

  return cmReview.reasonCode as P2PayCmReviewReasonCode
}

export const hasP2PayCancelWithdrawalAction = (cmReview: unknown): boolean => {
  if (
    !isRecord(cmReview)
    || cmReview.version !== 1
    || !Array.isArray(cmReview.availableActions)
  ) {
    return false
  }

  return cmReview.availableActions.some(
    action => isRecord(action)
      && action.code === P2PAY_CANCEL_WITHDRAWAL_ACTION
      && action.version === P2PAY_CANCEL_WITHDRAWAL_ACTION_VERSION,
  )
}

export const canRequestP2PayCancellation = (
  paymentName: unknown,
  cmReview: unknown,
  hasPermission: boolean,
): boolean => hasPermission
  && isP2PayWithdrawPaymentName(paymentName)
  && hasP2PayCancelWithdrawalAction(cmReview)

export const getP2PayCancellationOutcome = (
  httpStatus: unknown,
): P2PayCancellationOutcome => {
  if (httpStatus === 200 || httpStatus === 202) return 'ACCEPTED'
  if (httpStatus === 409) return 'REJECTED'
  if (
    typeof httpStatus !== 'number'
    || httpStatus === 408
    || httpStatus >= 500
    || (httpStatus >= 200 && httpStatus < 400)
  ) return 'UNKNOWN'
  return 'FAILED'
}

export const buildP2PayCancellationRequest = (
  transferId: number,
  requestId: string,
): P2PayCancellationRequest => ({ transferId, requestId })
